import WebFont from 'webfontloader'

export default function loadWebFont(parsedSettings) {
  if (parsedSettings.shouldLoadWebFont) {
    WebFont.load({
      google: {
        families: [parsedSettings.fontFamily],
      },
    })
  }
}
